module.exports = __webpack_public_path__ + "static/media/glacier.6df190e9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/glacier.png
 ** module id = 193
 ** module chunks = 0
 **/